import axiosInstance from "../app/axios";

export const getCountries = async () => {
  const result = await axiosInstance.get("countries", {
    headers: { "x-hide-success": true },
  });
  return result.data;
};

export const updateCountry = async (id: number, data: any) => {
  const result = await axiosInstance.patch(`countries/${id}`, data);
  return result.data;
};
